import React, { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";

const Projects = () => {

  const [projects, setProjects] = useState([]);
  const [comments, setComments] = useState({});
  const [searchBy, setSearchBy] = useState("");
  const [searchValue, setSearchValue] = useState("");
 

  // FETCH PROJECTS
  const fetchProjects = async () => {

    try {

      const response = await Axios.get("/api/courses/projects");

      console.log(response.data);

      setProjects(response.data);

    } catch (error) {

      console.log("PROJECT ERROR =>", error);

    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  // TOGGLE STATUS
  const toggleStatus = async (id, currentStatus) => {

    try {

      const newStatus =
        currentStatus === "active"
          ? "inactive"
          : "active";

      await Axios.put(
        `/api/courses/projects/${id}`,
        {
          status: newStatus
        }
      );

      alert(
        `Project ${
          newStatus === "active"
            ? "Activated"
            : "Inactivated"
        } Successfully`
      );

      fetchProjects();

    } catch (error) {

      console.log("STATUS UPDATE ERROR =>", error);

      alert("Status Update Failed");

    }
  };

  // HANDLE COMMENT CHANGE
  const handleCommentChange = (id, value) => {

    setComments({
      ...comments,
      [id]: value
    });

  };

  // SAVE COMMENT
  const saveComment = async (id, oldComment) => {

    try {

      const newComment = comments[id] || "";

      if (!newComment.trim()) {
        return alert("Please Enter Comment");
      }
      

      // COMMENT COUNT
      const commentLines =
        oldComment
          ? oldComment.split("\n")
          : [];

      const nextNumber =
        commentLines.length + 1;

      // FINAL COMMENT
      const updatedComment =
        oldComment
          ? `${oldComment}\n${nextNumber}. ${newComment}`
          : `1. ${newComment}`;

      await Axios.put(
        `/api/courses/projects/${id}`,
        {
          comment: updatedComment
        }
      );

      alert("Comment Saved Successfully");

      // CLEAR INPUT
      setComments({
        ...comments,
        [id]: ""
      });

      fetchProjects();

    } catch (error) {

      console.log("COMMENT ERROR =>", error);

      alert("Comment Save Failed");

    }
  };
 

  return (
    <div className="container mt-4">

      <center>
        <h2 className="mb-4">Projects</h2>
      </center>

      <div
  style={{
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "650px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    background: "#fff",
    padding: "10px"
  }}
>
  {/* SEARCH PANEL */}

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "18px",
    flexWrap: "wrap",
    justifyContent: "center"
  }}
>

  <h5 style={{ margin: "0" }}>
    Search By :
  </h5>

  {/* SELECT */}
  <select
    className="form-select"
    value={searchBy}
    onChange={(e) =>
      setSearchBy(e.target.value)
    }
    style={{
      width: "180px",
      height: "45px",
      fontSize: "16px",
      borderRadius: "8px"
    }}
  >
    <option value="">
      Select
    </option>

    <option value="business_id">
      Business ID
    </option>

    <option value="business_name">
      Business Name
    </option>

    <option value="contact_number">
      Contact No.
    </option>

  </select>

  {/* INPUT */}
  <input
    type="text"
    className="form-control"
    placeholder="Search..."
    value={searchValue}
    onChange={(e) =>
      setSearchValue(e.target.value)
    }
    style={{
      width: "260px",
      height: "45px",
      fontSize: "16px",
      borderRadius: "8px"
    }}
  />

  {/* SEARCH BUTTON */}
  <button
    className="btn btn-primary"
    style={{
      height: "35px",
      minWidth: "100px",
      borderRadius: "8px",
      fontSize: "17px",
      fontWeight: "600",
      background:
        "linear-gradient(to right, #6a11cb, #2575fc)",
      border: "none"
    }}
  >
    Search
  </button>

  {/* REMOVE FILTER */}
  <button
    className="btn btn-primary"
    onClick={() => {
      setSearchBy("");
      setSearchValue("");
    }}
    style={{
      height: "35px",
      minWidth: "100px",
      borderRadius: "8px",
      fontSize: "17px",
      fontWeight: "600",
      background: "#0d6efd",
      border: "none"
    }}
  >
    Remove Filter
  </button>

</div>

  <table
    className="table table-bordered table-hover align-middle"
    style={{
      minWidth: "1450px",
      borderCollapse: "separate",
      borderSpacing: "0 10px"
    }}
  >

    <thead className="table-dark">

      <tr>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          S.No
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Business ID
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Business Name
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Contact No.
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Project Name
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Tech Stack
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Budget
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Timeline
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          File
        </th>

        <th
          style={{
            width: "240px",
            padding: "14px 18px",
            whiteSpace: "nowrap"
          }}
        >
          Comments
        </th>

        <th style={{ padding: "14px 18px", whiteSpace: "nowrap" }}>
          Status
        </th>

      </tr>

    </thead>

    <tbody>

      {projects.length > 0 ? (

        projects
  .filter((item) => {

    if (!searchBy || !searchValue) {
      return true;
    }

    return String(
      item[searchBy] || ""
    )
      .toLowerCase()
      .includes(
        searchValue.toLowerCase()
      );

  })
  .map((item, index) => (

          <tr
            key={item.id}
            style={{
              background: "#fff"
            }}
          >

            <td style={{ padding: "16px" }}>
              {index + 1}
            </td>

            <td style={{ padding: "16px", lineHeight: "28px" }}>
              {item.business_id || "-"}
            </td>

            <td style={{ padding: "16px" }}>
              {item.business_name || "-"}
            </td>

            <td style={{ padding: "16px" }}>
              {item.contact_number || "-"}
            </td>

            <td style={{ padding: "16px", lineHeight: "28px" }}>
              {item.Proj_Name || "-"}
            </td>

            <td style={{ padding: "16px", lineHeight: "30px" }}>
              {item.TechStack || "-"}
            </td>

            <td style={{ padding: "16px" }}>
              {item.Budget || "-"}
            </td>

            <td style={{ padding: "16px" }}>
              {item.Timeline || "-"}
            </td>

            <td style={{ padding: "16px" }}>
              {item.FileUpload ? (
                <a
                  href={`${item.FileUpload}?alt=media`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#0d6efd",
                    fontWeight: "600",
                    textDecoration: "none"
                  }}
                >
                  Project file
                </a>
              ) : (
                "-"
              )}
            </td>

            {/* COMMENT SECTION */}
            <td
              style={{
                width: "240px",
                padding: "16px"
              }}
            >

              {/* TOP BUTTONS */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  marginBottom: "12px",
                  flexWrap: "nowrap",
                  alignItems: "center"
                }}
              >

                {/* ADMIN BUTTON */}
                <button
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target={`#adminModal${item.id}`}
                  style={{
                    minWidth: "90px",
                    height: "38px",
                    fontWeight: "600"
                  }}
                >
                  Admin
                </button>

                {/* PARTNER BUTTON */}
                <button
                  className="btn btn-success btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target={`#partnerModal${item.id}`}
                  style={{
                    minWidth: "90px",
                    height: "38px",
                    fontWeight: "600"
                  }}
                >
                  Partner
                </button>

              </div>

              {/* ================= ADMIN MODAL ================= */}

              <div
                className="modal fade"
                id={`adminModal${item.id}`}
                tabIndex="-1"
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">

                    <div className="modal-header">
                      <h5 className="modal-title">
                        Admin Comments
                      </h5>

                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                      />
                    </div>

                    <div className="modal-body">

{/* INPUT + BUTTONS */}
<div
  style={{
    display: "flex",
    gap: "10px",
    marginBottom: "15px",
    alignItems: "flex-start"
  }}
>

  {/* TEXTAREA */}
  <textarea
    className="form-control"
    placeholder="Enter Admin Comment"
    rows="4"
    value={comments[item.id] || ""}
    onChange={(e) =>
      handleCommentChange(
        item.id,
        e.target.value
      )
    }
    style={{
      resize: "none"
    }}
  />

  {/* BUTTON SECTION */}
  <div
    style={{
      display: "flex",
      gap: "8px"
    }}
  >

    {/* SAVE BUTTON */}
    <button
      className="btn btn-primary"
      style={{
        minWidth: "70px",
        height: "42px",
        fontWeight: "600",
        fontSize: "15px"
      }}
      onClick={() =>
        saveComment(
          item.id,
          ""
        )
      }
    >
      Save
    </button>

    {/* EDIT BUTTON */}
    <button
      className="btn btn-warning"
      style={{
        minWidth: "70px",
        height: "42px",
        fontWeight: "600",
        fontSize: "15px",
        color: "#fff"
      }}
      onClick={() => {

        setComments({
          ...comments,
          [item.id]: item.comment || ""
        });

      }}
    >
      Edit
    </button>

  </div>

</div>

                      {/* COMMENT BOX */}
                      <div
                        style={{
                          background: "#f8f9fa",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          padding: "15px",
                          maxHeight: "300px",
                          overflowY: "auto",
                          whiteSpace: "pre-line",
                          lineHeight: "28px"
                        }}
                      >
                        {item.comment || "No Admin Comments Yet"}
                      </div>
        

                    </div>

                  </div>
                </div>
              </div>

           {/* ================= PARTNER MODAL ================= */}

<div
  className="modal fade"
  id={`partnerModal${item.id}`}
  tabIndex="-1"
>
  <div className="modal-dialog modal-lg">
    <div className="modal-content">

      <div className="modal-header">
        <h5 className="modal-title">
          Partner Comments
        </h5>

        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
        />
      </div>

      <div className="modal-body">

        {/* COMMENT BOX */}
        <div
          style={{
            background: "#f8f9fa",
            border: "1px solid #ddd",
            borderRadius: "8px",
            padding: "15px",
            minHeight: "180px",
            whiteSpace: "pre-line",
            lineHeight: "28px",
            overflowY: "auto",
            maxHeight: "350px"
          }}
        >
         {item.comments ||
  "No Partner Comments Yet"}
        </div>

      </div>

    </div>
  </div>
</div>

            </td>

            {/* STATUS */}
            <td style={{ padding: "16px" }}>

              <span
                onClick={() =>
                  toggleStatus(
                    item.id,
                    item.status
                  )
                }
                className={`badge ${
                  item.status === "active"
                    ? "bg-success"
                    : "bg-danger"
                }`}
                style={{
                  cursor: "pointer",
                  padding: "8px 12px",
                  fontSize: "14px"
                }}
              >
                {item.status === "active"
                  ? "Active"
                  : "Inactive"}
              </span>

            </td>

          </tr>

        ))

      ) : (

        <tr>
          <td
            colSpan="11"
            className="text-center"
          >
            No Projects Found
          </td>
        </tr>

      )}

    </tbody>

  </table>

</div>
</div>
  );
};

export default Projects;